import React, { Component } from 'react';
import Select from 'react-select';
import queryString from 'query-string';
import NumberFormat from 'react-number-format';
import moment from 'moment';

import DateRange from './DateRange';
import LocationOption from '../../_components/Options/LocationOption';
import ProfessionalOption from '../../_components/Options/ProfessionalOption';
import { history } from '../../_helpers/history';
import FormOption from '../../_components/Options/FormOption';

class SearchFilters extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstName: '',
      lastName: '',
      location: '',
      professional: '',
      status: '',
      completedOn: '',
      completedOnStart: '',
      completedOnEnd: '',
      questionnaire: '',
      invalidDate: false,
      invalidStart: false,
      invalidEnd: false,
      showDateRange: false
    }

    this.statusOptions = [
      { value: 'IN_PROGRESS', label: 'In-Progress' },
      { value: 'COMPLETED', label: 'Completed' },
    ];

    this.setParams = this.setParams.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleDateRange = this.toggleDateRange.bind(this);
  }

  componentDidMount() {
    this.setParams()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setParams();
    }
  }

  toggleDateRange(e) {
    e.preventDefault();
    if (this.state.showDateRange) {
      this.setState({ completedOnStart: "", completedOnEnd: "" })
    } else {
      this.setState({ completedOn: "" })
    }
    this.setState((prevState) => {
      return { ...prevState, showDateRange: !prevState.showDateRange }
    });
  }

  setParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("completedOnStart" in queryParams) ? true : false;

    this.setState({
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      location: queryParams.location ? parseInt(queryParams.location) : '',
      professional: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      showDateRange: showDateRange,
      completedOn: queryParams.completedOn || '',
      completedOnStart: showDateRange && queryParams.completedOnStart ? new Date(queryParams.completedOnStart) || '' : '',
      completedOnEnd: showDateRange && queryParams.completedOnEnd ? new Date(queryParams.completedOnEnd) || '' : '',
      questionnaire: queryParams.questionnaire ? parseInt(queryParams.questionnaire) : '',
    });
  }

  handleSearch() {
    this.setState({ invalidDate: false, invalidStart: false, invalidEnd: false });
    const { completedOn, completedOnStart, completedOnEnd } = this.state;

    if (this.state.showDateRange) {
      if (!completedOnStart && completedOnEnd) {
        return this.setState({ invalidStart: true })
      }
      if (completedOnStart && !completedOnEnd) {
        return this.setState({ invalidEnd: true })
      }
    } else {
      if (completedOn && completedOn.replace(/\D/g, '').length !== 8) {
        return this.setState({ invalidDate: true })
      }
      if (completedOn && !moment(completedOn, 'MM/DD/YYYY').isValid()) {
        return this.setState({ invalidDate: true })
      }
    }
    this.props.handleSearch(this.state);
  }

  render() {
    const statusSelected = this.statusOptions.find((option) => {
      return option.value === this.state.status
    });

    return <div className="card axs-shadow">
      <div className="card-header">
        <h5>Search Filters</h5>
      </div>
      <div className="card-body">
        <form>
          <div className="form-group">
            <label htmlFor="patientFirstName">Patient First Name</label>
            <input onChange={e => this.setState({ firstName: e.target.value })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.firstName || ''}
              type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label htmlFor="patientLastName">Patient Last Name</label>
            <input onChange={(e) => this.setState({ lastName: e.target.value })}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  this.handleSearch();
                }
              }}
              value={this.state.lastName || ''}
              type="text" className="form-control" />
          </div>

          <div className="form-group">
            <label htmlFor="completedOn">Completed On</label>
            {this.state.showDateRange ?
              <DateRange
                startDate={this.state.completedOnStart}
                endDate={this.state.completedOnEnd}
                invalidStart={this.state.invalidStart}
                invalidEnd={this.state.invalidEnd}
                handleSearch={this.handleSearch} setStartDate={(date) => this.setState({ completedOnStart: date })}
                setEndDate={(date) => this.setState({ completedOnEnd: date })}
              />
              :
              <NumberFormat
                onValueChange={(e) => this.setState({ completedOn: e.formattedValue })}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    this.handleSearch();
                  }
                }}
                value={this.state.completedOn || ''}
                format="##/##/####"
                mask="_"
                name="completedOn"
                className={`form-control ${this.state.invalidDate ? 'is-invalid' : ''}`}
                placeholder="__/__/____"
              />
            }
            <div className="mt-1">
              <a href="/" onClick={this.toggleDateRange}>
                {this.state.showDateRange ? "Date Only" : "Date Range"}
              </a>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="providerGroup">Location</label>
            <LocationOption defaultValue={this.state.location}
              handleSelected={(location) => {
                this.setState({ location });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="provider">Provider</label>
            <ProfessionalOption defaultValue={this.state.professional}
              handleSelected={(professional) => {
                this.setState({ professional });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="providerGroup">Form</label>

            <FormOption defaultValue={this.state.questionnaire}
              handleSelected={questionnaire => {
                this.setState({ questionnaire });
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <Select
              placeholder='By Status'
              isClearable={true}
              options={this.statusOptions}
              onChange={(selected) => {
                if (selected) {
                  this.setState({ status: selected.value })
                } else {
                  this.setState({ status: '' });
                }
              }}
              value={statusSelected || ''}
            />
          </div>

          <button onClick={this.handleSearch} type="button" className="btn btn-primary btn-block">Search</button>

          <button onClick={() => history.push('/intake')} type="button" className="btn btn-link btn-block text-center">Clear Filters</button>
        </form>
      </div>
    </div>
  }
}

export default SearchFilters;